// removed by extract-text-webpack-plugin
module.exports = {"btn":"_1SuFiGqo0rN1C7ZCO2mmph","loading":"_3Abw0ssQvNy9nyz-dKIvSk","success":"_1LCpmgZ-fm40lOF16Z5kgp","danger":"_2wZgfdrLcUyHnvjbie-u4p","rounded":"_26mEcOknAIg_RBwOYFUCpt","rounded-orange":"_1nKtZgHs9XIXI9YCWiVuox","semi-rounded-orange":"-Z9_fqgmXHtpDYPKn3AFR","light":"_2ge4NncKwjV49XfpIMr5PX"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/ActionBtn/style.css
// module id = 632
// module chunks = 38